import * as type from '../mutation-type'
import * as globalApi from '../../api/global.js'
import * as authApi from '../../api/auth.js'
import {getToken, removeToken} from '@/utils/auth'

const state = {
  payload: {},
  currentUser: {},
  menu: {},
  hasLogin: {}
}

const getters = {
  currentUser: state => state.currentUser,
  menu: state => state.menu,
  hasLogin: state => state.hasLogin
}

const actions = {
  getCurrentUser ({ commit }) {
    return globalApi.currentUser().then(res => {
      commit(type.SET_CURRENT_USER, res.data)
    })
  },
  getMenu ({ commit, state }, { userId }) {
    globalApi.getMenu(userId).then(res => {
      const ops1 = {
        icon: 'el-icon-user',
        index: 'system-administration',
        text: '系统后台管理',
        children: {
          '0': {
            index: '/manage/user/list',
            link: {
              name: 'manage-user-list'
            },
            name: 'manage-user-list',
            text: '用户管理'
          },
          '3': {
            index: '/manage/dyuser/list',
            link: {
              name: 'manage-dyuser-list'
            },
            name: 'manage-dyuser-list',
            text: '度言坐席管理'
          },
          '1': {
            index: '/mechanism',
            link: {
              name: 'mechanism'
            },
            name: 'mechanism',
            text: '组织机构管理'
          },
          '2': {
            index: '/template',
            link: {
              name: 'template'
            },
            name: 'template',
            text: '模板管理'
          }
        }
      }
      // const ops2 = {
      //   icon: 'el-icon-tickets',
      //   index: 'caseManagement',
      //   text: '案件管理',
      //   children: {
      //     '0': {
      //       index: 'management-queues',
      //       text: '队列管理',
      //       children: {
      //         '0': {
      //           index: '/manage/queue',
      //           link: {
      //             query: {
      //               type: 'manual'
      //             }
      //           },
      //           text: '手工队列'
      //         },
      //         '1': {
      //           index: '/manage/autoQueue',
      //           link: {
      //             query: {
      //               type: 'auto'
      //             }
      //           },
      //           text: '自动队列'
      //         }
      //       }
      //     }
      //   }
      // }
      const ops3 = {
        icon: 'el-icon-download',
        index: 'downloadManage',
        text: '下载中心管理',
        children: {
          '0': {
            index: '/download',
            link: {
              name: 'download'
            },
            name: 'download',
            text: '下载中心'
          }
        }
      }
      const ops4 = {
        icon: 'el-icon-document',
        index: 'reportExport',
        text: '报表管理',
        children: {
          '0': {
            index: '/comReportExport',
            link: {
              name: 'comReportExport'
            },
            name: 'comReportExport',
            text: '委案报表导出'
          },
          '1': {
            index: '/overdueReportExport',
            link: {
              name: 'overdueReportExport'
            },
            name: 'overdueReportExport',
            text: '逾期表导出'
          },
          '2': {
            index: '/outsourceBillReportExport',
            link: {
              name: 'outsourceBillReportExport'
            },
            name: 'outsourceBillReportExport',
            text: '委外清单报表导出'
          }
        }
      }
      if (state.currentUser.role === 3) res.data.push(ops1)
      if (state.currentUser.role === 1 || state.currentUser.role === 2 || state.currentUser.role === 3) res.data.push(ops4)
      if (state.currentUser.role === 1 || state.currentUser.role === 2 || state.currentUser.role === 3) res.data.push(ops3)
      // if (state.currentUser.role === 3 || state.currentUser.role === 2) res.data.unshift(ops2)
      commit(type.SET_MENU, res.data)
    })
  },
  // 登录（密码，保留作为兜底）
  Login ({ commit }, userInfo) {
    const username = userInfo.username.trim()
    return new Promise((resolve, reject) => {
      globalApi.login(username, userInfo.password).then(response => {
        if (response.data.loginResult === 'success') {
          const token = getToken()
          console.log(token)
          commit(type.SET_HASLOGIN, token.hasLogin)
          commit(type.SET_CURRENT_USER, response.data.userInfo)
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 短信验证码登录
  SmsLogin ({ commit }, { mobile, code }) {
    return new Promise((resolve, reject) => {
      authApi.smsLogin(mobile, code).then(response => {
        if (response && response.data && response.data.loginResult === 'success') {
          const token = getToken()
          commit(type.SET_HASLOGIN, token.hasLogin)
          commit(type.SET_CURRENT_USER, response.data.userInfo)
          resolve()
        } else {
          reject(new Error('login failed'))
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 登出
  LogOut ({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit(type.SET_HASLOGIN, '')
      removeToken()
      resolve()
    })
  }
}

const mutations = {
  [type.EXAMPLE_MUTATION] (state, params) {
    state.payload = params
  },
  [type.SET_CURRENT_USER] (state, params) {
    state.currentUser = params
  },
  [type.SET_MENU] (state, params) {
    state.menu = params
  },
  [type.SET_HASLOGIN] (state, params) {
    state.hasLogin = params
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
